import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private serverSettings: { [key: string]: any } = {};

  public setServerSettings(settings: { [key: string]: any }): void {
    this.serverSettings = settings;
  }

  public getServerSetting(key: string): any {
    return this.serverSettings[key] || null;
  }

}
